import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import WorkoutFolderCard from "./WorkoutFolderCard";

const openCreateFolderModal = () => {
  submit("/actions/refresh", {
    method: "GET",
    body: {
      "modal[type]": "handle-workout-folder",
    },
  });
};

const WorkoutFoldersEmptyState = () => {
  const { t } = useTranslation("coaching-portal");

  return (
    <div className="workout-folders-empty">
      <SvgIcon
        src="/img/new-icons/folder.svg"
        classNames="workout-folders-empty-icon"
        useCurrentColor={true}
      />
      <div className="workout-folders-empty-text">
        <h4>{t("allTemplates.workoutFolders.emptyTitle", "No folders yet")}</h4>
        <p>
          {t(
            "allTemplates.workoutFolders.emptySubtitle",
            "Create folders to organize workouts by goal, athlete, or training phase."
          )}
        </p>
      </div>
      <button
        type="button"
        className="workout-folders-empty-action"
        onClick={openCreateFolderModal}
      >
        {t("allTemplates.workoutFolders.createFolder", "Create Folder")}
      </button>
    </div>
  );
};

const CreateFolderTile = () => {
  const { t } = useTranslation("coaching-portal");

  return (
    <button
      type="button"
      className="workout-folder-create-tile"
      onClick={openCreateFolderModal}
    >
      <SvgIcon src="/img/new-icons/add.svg" />
      <span>
        {t("allTemplates.workoutFolders.createNewFolder", "Create New Folder")}
      </span>
    </button>
  );
};

const countWorkoutsInFolder = (folder, savedWorkoutIds) => {
  const ids = folder.workoutIds || [];
  return ids.filter((id) => savedWorkoutIds.has(String(id))).length;
};

const WorkoutFoldersSection = ({ folders = [], savedWorkouts = [] }) => {
  const { t } = useTranslation("coaching-portal");
  const savedWorkoutIds = new Set(savedWorkouts.map((w) => String(w._id)));
  const hasFolders = folders.length > 0;
  const [descriptionsExpanded, setDescriptionsExpanded] = useState(false);
  const toggleDescriptionsExpanded = useCallback(
    () => setDescriptionsExpanded((expanded) => !expanded),
    []
  );

  return (
    <section className="workout-folders-section">
      <h3 className="workout-folders-section-title">
        {t("allTemplates.workoutFolders.sectionTitle", "Folders")}
      </h3>
      {!hasFolders ? (
        <WorkoutFoldersEmptyState />
      ) : (
        <div className="workout-folders-grid">
          {folders.map((folder) => (
            <WorkoutFolderCard
              key={folder._id}
              folder={folder}
              workoutCount={countWorkoutsInFolder(folder, savedWorkoutIds)}
              descriptionExpanded={descriptionsExpanded}
              onToggleDescriptionExpanded={toggleDescriptionsExpanded}
            />
          ))}
          <CreateFolderTile />
        </div>
      )}
    </section>
  );
};

WorkoutFoldersSection.propTypes = {
  folders: PropTypes.array,
  savedWorkouts: PropTypes.array,
};

export default WorkoutFoldersSection;
